//
export const toKebabCase = (entry = '') =>
  entry
    .replace(/\s+/g, '-')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // camelCase a kebab
    .toLowerCase()
    .replace(/^-+/, '');
export default toKebabCase;
